import { Component } from '@angular/core';

const CARD_RADIUS = '1rem';

/** Loading placeholder shaped like the snapshot: four tiles, hero, five list rows. */
@Component({
  selector: 'ifbp-snapshot-skeleton',
  templateUrl: './snapshot-skeleton.component.html',
  styleUrls: ['./snapshot-skeleton.component.scss'],
  standalone: false,
})
export class SnapshotSkeletonComponent {
  readonly tiles = [0, 1, 2, 3];
  readonly heroTheme = { height: '17.75rem', 'border-radius': CARD_RADIUS, margin: 0 };
  readonly tileTheme = { height: '8rem', 'border-radius': CARD_RADIUS, margin: 0 };
  readonly listTheme = { height: '2.5rem', margin: '0 0 0.5rem' };

  trackByIndex(index: number): number {
    return index;
  }
}
